import React from 'react';

export const MeasurementInput = ({ label, value, onChange, onBlur, name, type = 'text', placeholder = '' }) => {
  return (
    <div className="flex flex-col">
      <label className="text-[10px] md:text-xs uppercase tracking-[0.15em] text-muted-foreground mb-1.5 block">
        {label}
      </label>
      <input
        type={type}
        name={name}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        className="flex h-9 w-full rounded-none border-b border-input bg-transparent px-0 py-1 text-sm shadow-none transition-colors focus-visible:outline-none focus-visible:border-black disabled:cursor-not-allowed disabled:opacity-50 placeholder:text-muted-foreground/30"
      />
    </div>
  );
};